{
    // Fix role and keyboard barriers with cookies button
    const cookieSettingsLink = document.querySelectorAll('.ot-sdk-show-settings');

    Array.from(cookieSettingsLink).forEach(settingsLink => {
        settingsLink.tabIndex = 0;

        settingsLink.setAttribute('role', 'button');
    
        settingsLink.addEventListener('keyup', function(e) {
            if (e.code === 'Enter' || e.code === 'Space') {
                e.preventDefault();
                settingsLink.click();
            }
        });
    });
}